export default __webpack_public_path__ + "static/media/home-page-background.27cf518c.jpeg";